import React from 'react';
import {FeedCard} from "./FeedCard";

export default React.memo(FeedCard)